<template>
  <div class="gift-card__form-item gift-card__card">
    <div class="gift-card__title">
      <div class="gift-card__form-label">Данные получателя карты</div>
      <div class="gift-card__remove" v-if="canBeRemoved">
        <button class="remove-card btn" @click.prevent="deleteCard">Удалить карту</button>
      </div>
    </div>
    <div class="gift-card__card-top">
      <div class="gift-card__col col-3 clearfix">
        <div class="form_row required" :class="{ 'error': $v.fields.recipient.lastName.$error }">
          <label><span>Фамилия</span><span class="req">*</span></label>
          <input class="form-control" type="text" v-model="fields.recipient['lastName']" name="lastName" value="" required>
        </div>
        <div class="form_row required" :class="{ 'error': $v.fields.recipient.name.$error }">
          <label><span>Имя</span><span class="req">*</span></label>
          <input class="form-control" type="text" v-model="fields.recipient['name']" name="name" value="" required>
        </div>
        <div class="form_row required" :class="{ 'error': $v.fields.recipient.phone.$error }">
          <label><span>Телефон</span> <span class="req">*</span></label>
          <input class="form-control mask-phone" type="text" @blur="updatePhone" name="phone" maxlength="" value="">
        </div>
      </div>
      <div class="gift-card__range">
        <div class="gift-card__range-top">
          <div class="gift-card__range-label">Выберите номинал карты:</div>
          <div class="gift-card__range-summ">
            <input class="gift-card__range-input" :id="'range-val_'+ id"  v-model="fields.nominal" name="nominal" type="text">
            &nbsp;₽
          </div>
        </div>
        <Slider
            v-model="fields.nominal"
            :min="500"
            :max="150000"
        />
      </div>
    </div>
    <div class="gift-card__card-bottom">

      <div class="gift-card__design">
        <label class="gift-card__design-label"><span>Выберите дизайн карты:</span></label>
        <div class="gift-card__design-img">
          <img :src="designChoseLink" alt="" loading="lazy">
          <a class="fancybox gift-card__design-btn" @click.prevent="$emit('setDesignId', id)" href="#card-design">Выбрать дизайн</a>
        </div>
      </div>
      <div class="gift-card__col col-2 clearfix">
        <div class="form_row form_row--2">
          <label>
            <span>Добавьте текст поздравления</span>
          </label>
          <textarea class="form-control" v-model="fields.payload['text']"></textarea>
        </div>
        <div class="form_row" :class="{ 'error': $v.fields.payload.sender.required && $v.fields.payload.sender.$error}">
          <label>
            <span>Подпись (от кого)</span>
            <template v-if="!fields.payload.anonymous"><span class="req">*</span></template>
          </label>
          <input class="form-control" type="text" v-model="fields.payload['sender']" name="sender" :required="!fields.payload.anonymous" :disabled="fields.payload.anonymous">
          <div class="checkbox f_checkbox">
            <input class="form-control" type="checkbox" :id="'anonymous_'+ id" name="anonymous" v-model="fields.payload.anonymous">
            <label :for="'anonymous_'+ id">Отправить анонимно</label>
          </div>
        </div>
        <div class="form_row send_time" :class="{ 'error': $v.fields.payload.dateToSend.$error }">
          <label>
            <span>Время отправления</span><span class="req">*</span>
          </label>
          <input class="form-control form-time" type="time" v-model="fields.payload['timeToSend']" name="timeToSend" required>
        </div>
        <div class="form_row" :class="{ 'error': $v.fields.payload.timeToSend.$error }">
          <label>
            <span>Дата отправления</span><span class="req">*</span>
          </label>
          <input class="form-control form-date" type="date" v-model="fields.payload['dateToSend']" name="dateToSend" required>
        </div>
        <div class="form_row">
          <label>
            <span>Часовой пояс</span>
          </label>
          <select v-if="timezones.length > 0" class="selectize form-control form-item form-select" v-model="fields.payload['timezone']" name="timezone">
            <option v-for="(time, index) in timezones" :key="index" :value="time['value']" :selected="index === 0">{{ time.text }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import Slider from '@vueform/slider/dist/slider.vue2.js'
import {required, requiredIf} from 'vuelidate/lib/validators'

let $ = window.$ || {};
export default {
  name: "CardDataForm",
  components: {Slider},
  props: {
    timezones: {
      type: Array,
      default: (() => [])
    },
    canBeRemoved: {
      type: Boolean,
      default: false,
    },
    designs: {
      type: Array,
      default: (() => [])
    },
    cardNum: {
      type: Number,
      required: true,
    }
  },
  data: () => ({
    fields: {
      recipient: {
        name: "",
        lastName: "",
        phone: "",
      },
      nominal: 2000,
      design: 0,
      payload: {
        text: "",
        sender: "",
        anonymous: false,
        timeToSend: "",
        dateToSend: "",
        timezone: 2,
      },
    },
    emptyFields: {},
    id: 0,
    designChoseLink: '',
  }),
  validations: {
    fields: {
      recipient: {
        name: {required,},
        lastName: {required,},
        phone: {required},
      },
      design: {required},
      nominal: {required},
      payload: {
        sender: {
          required: requiredIf( function (  ) {
            return !this.fields.payload.anonymous;
          })
        },
        timeToSend: {required},
        dateToSend: {required},
      },
    },
  },
  created()
  {
    this.id = Math.random().toString( 16 ).slice( 2 );
    if ( this.designs.length > 0 )
    {
      this.$nextTick( window.giftCardCallery );
      this.fields.design = this.designs[0].id;
      this.designChoseLink = this.designs[0].photo;
    }
  },
  mounted()
  {
    if ( this.nominals )
    {
      this.$set( this.fields, 'nominal', this.nominals[ 0 ] );
    }
    this.emptyFields = JSON.parse( JSON.stringify( this.fields ) );
    this.$emit( 'setCardFields', {num: this.cardNum, fields: this.fields} );
    setPhoneMask( document.querySelectorAll( "[name='phone']" ) );

  },
  watch: {
    "fields.recipient.name"( newValue, oldValue )
    {
      let matched = newValue.match( /[^А-ЯЁA-Za-z\s]/gi );
      if ( matched !== null )
      {
        return this.fields.recipient.name = oldValue;
      }
    },
    "fields.recipient.lastName"( newValue, oldValue )
    {
      let matched = newValue.match( /[^А-ЯЁA-Za-z\s]/gi );
      if ( matched !== null )
      {
        return this.fields.recipient.lastName = oldValue;
      }
    },
    "fields.payload.sender"( newValue, oldValue )
    {
      let matched = newValue.match( /[^А-ЯЁA-Za-z\s]/gi );
      if ( matched !== null )
      {
        return this.fields.payload.sender = oldValue;
      }
    },
    "fields.payload.anonymous"( newValue, oldValue )
    {
      if ( newValue === true )
      {
        this.fields.payload.sender = "";
      }
    },
    fields:
    {
      deep: true,
      handler( value )
      {
        this.$emit( 'setCardFields', {num: this.cardNum, fields: value} );
      }
    },
    designs( )
    {
      this.$nextTick( window.giftCardCallery );
      this.fields.design = this.designs[0].id;
      this.designChoseLink = this.designs[0].photo;
    },
  },
  methods:
      {
        clearCard()
        {
          this.fields = JSON.parse( JSON.stringify( this.emptyFields ) );
          this.$v.$reset();
        },
        deleteCard()
        {
          this.$emit( 'decreaseCard', this.cardNum );
        },
        updatePhone( el )
        {
          this.fields.recipient.phone = el.target.value;
        },
        triggerVuelidate()
        {
          this.$v.$touch();
          return this.$v.$invalid;
        }
      },
}
</script>

<style scoped>
.gift-card__title {
  display: flex;
  flex-direction: row;
  position: relative;
}

.gift-card__remove {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

@media (max-width: 767px) {
  .gift-card__title {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 20px;
  }

  .gift-card__remove {
    position: static;
    transform: none;
  }
}
</style>